/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveConnectionSalesTypes from './receive-connection-sales-types';
import * as actions from 'state/action-types';

export default (salesTypeId = null, connectionSalesTypes) => (dispatch) => {
    const isNew = !salesTypeId;
    if (isNew) {
        return cecSdk
            .connectionSalesTypes()
            .add(connectionSalesTypes)
            .then((connectionSalesTypes) => {
                dispatch(receiveConnectionSalesTypes([connectionSalesTypes]));
                dispatch({ type: actions.SAVE_CONNECTION_SALES_TYPES_SUCCESS, payload: { connectionSalesTypes, isNew } });
            });
    }

    return cecSdk
        .connectionSalesTypes(salesTypeId)
        .update(connectionSalesTypes)
        .then((connectionSalesTypes) => {
            dispatch(receiveConnectionSalesTypes([connectionSalesTypes]));
            dispatch({ type: actions.SAVE_CONNECTION_SALES_TYPES_SUCCESS, payload: { connectionSalesTypes } });
        });
};